import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as settings from "../../constants/settings";
import * as rcc from "../../constants/rcc";
import * as navigationActions from "../../actions/navigationActions";
import * as rccActions from "../../actions/rccActions";

import CanisterLevelsModalComponent from "../../components/global/modal/CanisterLevelsModal";
import CanisterLevelsModalLightComponent from "../../components/global/modal/CanisterLevelsModalLight";

class CanisterLevelsModal extends Component {
    componentDidMount = () => {
        this.props.dispatchGetMachineCanistersAction();
    };

    closeModal = () => {
        this.props.dispatchCloseCanisterLevelModalAction();
    };

    setMaxDispenseLevel = (index, level) => {
        this.props.dispatchSetMaxDispenseLevelAction(index, level);
    };

    moveTableToRefill = (index) => {
        this.props.dispatchMoveTableToRefillAction(index);
    };

    startCanisterRefill = (index) => {
        this.props.dispatchStartCanisterRefillAction(index);
    };

    getCanisterImage = (canister) => {
        this.props.dispatchGetCanisterImageAction(canister);
    };

    render() {
        if (this.props.redlikeLightSoftware || this.props.gammaSoftware) {
            return (
                <CanisterLevelsModalLightComponent
                    tabId={this.props.tabId}
                    loggedUser={this.props.loggedUser}
                    rccUnit={this.props.rccUnit}
                    canisterList={this.props.canisterList}
                    colorantList={this.props.colorantList}
                    machine={this.props.machine}
                    imageStore={this.props.imageStore}
                    virtualKeyboardEnabled={this.props.virtualKeyboardEnabled}
                    closeModal={this.closeModal}
                    startCanisterRefill={this.startCanisterRefill}
                    setMaxDispenseLevel={this.setMaxDispenseLevel}
                    getCanisterImage={this.getCanisterImage}
                    weberSoftware={this.props.weberSoftware}
                    confirmCanisterRefill={this.props.dispatchConfirmCanisterRefillAction}
                />
            );
        }

        return (
            <CanisterLevelsModalComponent
                id={this.props.id}
                tabId={this.props.tabId}
                loggedUser={this.props.loggedUser}
                rccUnit={this.props.rccUnit}
                canisterList={this.props.canisterList}
                colorantList={this.props.colorantList}
                machine={this.props.machine}
                closeModal={this.closeModal}
                startCanisterRefill={this.startCanisterRefill}
                moveTableToRefill={this.moveTableToRefill}
                confirmCanisterRefill={this.props.dispatchConfirmCanisterRefillAction}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        gammaSoftware: store.module.gammaSoftware,
        loggedUser: store.login.loggedUser,
        rccUnit:
            store.rcc.machineConfigurationList === null
                ? settings.UNIT_ML
                : store.rcc.machineConfigurationList[rcc.CONFIG_UNIT],
        canisterList: store.rcc.canisterList,
        colorantList: store.global.allColorantList,
        machine: store.rcc.machine,
        weberSoftware: store.module.weberSoftware,
        virtualKeyboardEnabled: store.settings.virtualKeyboardEnabled,
        imageStore: store.navigation.imageStore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseCanisterLevelModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CANISTER_LEVELS_MODAL));
        },
        dispatchGetMachineCanistersAction: () => {
            dispatch(rccActions.getMachineCanisters());
        },
        dispatchMoveTableToRefillAction: (canisterIndex) => {
            dispatch(rccActions.moveTableToRefill(canisterIndex));
        },
        dispatchStartCanisterRefillAction: (index) => {
            dispatch(rccActions.startCanisterRefill(index));
        },
        dispatchGetCanisterImageAction: (canister) => {
            dispatch(rccActions.getCanisterImage(canister));
        },
        dispatchSetMaxDispenseLevelAction: (index, level) => {
            dispatch(rccActions.setMaxDispenseLevel(index, level));
        },
        dispatchConfirmCanisterRefillAction: (index, level, add, unitMl, type) => {
            dispatch(rccActions.confirmCanisterRefill(index, level, add, unitMl, type));
        }
    };
};

export default CanisterLevelsModal = connect(mapStoreToProps, mapDispatchToProps)(CanisterLevelsModal);
